'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by lyj on 2016/9/5.
                                          */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _reduxAsyncConnect = require('redux-async-connect');

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _orderWriting = require('redux/modules/orderWriting');

var orderWritingActions = _interopRequireWildcard(_orderWriting);

var _reactRouter = require('react-router');

var _background = require('redux/modules/background');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderWriting = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: true,
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;
    var params = _ref.params;

    var promises = [];
    promises.push(dispatch((0, _background.changeHeaderText)('订单填写')));
    promises.push(dispatch(orderWritingActions.getData(params.orderNumber)));
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    submitted: state.orderWriting.submitted,
    data: state.orderWriting.data,
    detailData: state.orderWriting.detailData,
    submitData: state.orderWriting.submitData,
    error: state.orderWriting.error,
    modalProductId: state.orderWriting.modalProductId,
    detailModalOpened: state.orderWriting.detailModalOpened
  };
}, (0, _extends3.default)({}, orderWritingActions, {
  routerPush: _reactRouterRedux.push
})), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(OrderWriting, _Component);

  function OrderWriting() {
    (0, _classCallCheck3.default)(this, OrderWriting);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(OrderWriting).call(this));

    _this.state = {
      errorOpened: false,
      errorTxt: ''
    };
    return _this;
  }

  (0, _createClass3.default)(OrderWriting, [{
    key: 'onSubmit',
    value: function onSubmit() {
      var _props = this.props;
      var submit = _props.submit;
      var routerPush = _props.routerPush;
      var data = _props.data;

      if (submit && data && data.info instanceof Array && data.info.length > 0) {
        var sumMoney = 0;
        if (!isNaN(parseFloat(data.info[0].sumMoney, 10))) {
          sumMoney = parseFloat(data.info[0].sumMoney, 10);
        }
        if (sumMoney > 0) {
          submit((0, _extends3.default)({}, data.info[0]), data.orderNumber).then(function (nextData) {
            if (nextData.isValid) {
              routerPush('/payment/' + nextData.payNumber + '/' + nextData.activeId);
            }
          });
        } else {
          this.setState({
            errorTxt: '订单信息有误',
            errorOpened: true
          });
        }
      }
    }
  }, {
    key: 'onDetailShow',
    value: function onDetailShow(productId) {
      var _props2 = this.props;
      var getDetail = _props2.getDetail;
      var openDetailModal = _props2.openDetailModal;
      var params = _props2.params;

      if (getDetail) {
        getDetail(productId, params.orderNumber).then(function () {
          openDetailModal(productId);
        });
      }
    }
  }, {
    key: 'onDetailModalClose',
    value: function onDetailModalClose() {
      var closeDetailModal = this.props.closeDetailModal;

      if (closeDetailModal) {
        closeDetailModal();
      }
    }
  }, {
    key: 'onCloseSuccessModal',
    value: function onCloseSuccessModal() {
      var clearSubmitError = this.props.clearSubmitError;

      if (clearSubmitError) {
        clearSubmitError();
      }
    }
  }, {
    key: 'onCloseErrorModal',
    value: function onCloseErrorModal() {
      this.setState({
        errorTxt: '',
        errorOpened: false
      });
    }
  }, {
    key: 'fieldChange',
    value: function fieldChange(val, field) {
      var _props3 = this.props;
      var fieldChange = _props3.fieldChange;
      var data = _props3.data;
      var params = _props3.params;

      if (data && data.info instanceof Array && data.info.length > 0) {
        var info = (0, _extends3.default)({}, data.info[0]);
        info[field] = val;
        fieldChange(info, field, params.orderNumber);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props;
      var data = _props4.data;
      var submitData = _props4.submitData;
      var detailData = _props4.detailData;
      var modalProductId = _props4.modalProductId;
      var detailModalOpened = _props4.detailModalOpened;
      var _state = this.state;
      var errorOpened = _state.errorOpened;
      var errorTxt = _state.errorTxt;

      var styles = require('./OrderWriting.scss');
      var returnDiv = _react2.default.createElement('div', null);
      var modalOpened = false;
      var modalText = '';
      if (submitData) {
        if (submitData.isValid === false) {
          modalOpened = true;
          modalText = submitData.message;
        }
      }
      if (data && data.info instanceof Array && data.info.length > 0) {
        returnDiv = _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_components.OrderWritingInfo, { data: data.info[0], fieldChange: this.fieldChange.bind(this) }),
          _react2.default.createElement(
            'div',
            { className: styles.singleItem },
            _react2.default.createElement(
              'div',
              { className: styles.title, style: { float: 'left' } },
              _react2.default.createElement(
                'i',
                null,
                _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/third/new_js_bg6.png', alt: '' })
              ),
              _react2.default.createElement(
                'span',
                null,
                '艺品信息'
              )
            ),
            _react2.default.createElement('div', { className: 'clear' }),
            _react2.default.createElement('div', { className: styles.alink }),
            _react2.default.createElement(_components.OrderWritingProductComponent, { data: data.productsPreviewDetailOfAuth,
              detailData: detailData,
              onDetailShow: this.onDetailShow.bind(this),
              onDetailModalClose: this.onDetailModalClose.bind(this),
              modalProductId: modalProductId,
              detailModalOpened: detailModalOpened }),
            _react2.default.createElement('div', { className: 'clear' }),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: styles.backToGWC, to: '/personalcenter/personalbuying/productpreselection' },
              '返回购物车'
            ),
            _react2.default.createElement('div', { className: 'clear' }),
            _react2.default.createElement(
              'div',
              { className: styles.boa + ' ' + styles.aa, onClick: this.onSubmit.bind(this) },
              _react2.default.createElement(
                'div',
                { className: styles.jin },
                '订单总额：',
                data.info[0].sumMoney
              ),
              _react2.default.createElement(
                'div',
                { className: styles.dui },
                _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/yuxuan/duia.png', alt: '' })
              ),
              _react2.default.createElement(
                'div',
                { className: styles.din },
                '提交订单'
              )
            )
          ),
          _react2.default.createElement('div', { className: 'clear' }),
          _react2.default.createElement(_components.SuccessModal, { isOpened: modalOpened, onSubmit: this.onCloseSuccessModal.bind(this),
            width: '400', text: modalText }),
          _react2.default.createElement(_components.AttentionSuccessModal, { isOpened: errorOpened,
            loginStyle: { background: 'url("http://tupian.goeasy.cn:9999/yipinwang/wbg/zhuce_sucess_1.png") no-repeat' },
            closeModalFunc: this.onCloseErrorModal.bind(this),
            text: errorTxt })
        );
      }
      return returnDiv;
    }
  }]);
  return OrderWriting;
}(_react.Component), _class2.propTypes = {
  dispatch: _react.PropTypes.func,
  data: _react.PropTypes.object,
  params: _react.PropTypes.object,
  submitData: _react.PropTypes.object,
  submitted: _react.PropTypes.bool,
  submit: _react.PropTypes.func,
  fieldChange: _react.PropTypes.func,
  clearSubmitError: _react.PropTypes.func,
  routerPush: _react.PropTypes.func,
  error: _react.PropTypes.string,
  getDetail: _react.PropTypes.func,
  openDetailModal: _react.PropTypes.func,
  closeDetailModal: _react.PropTypes.func,
  detailData: _react.PropTypes.object,
  detailModalOpened: _react.PropTypes.bool,
  modalProductId: _react.PropTypes.string
}, _temp)) || _class) || _class);
exports.default = OrderWriting;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/OrderWriting/OrderWriting.js
 ** module id = 1510
 ** module chunks = 0
 **/